export default (lineNum) => {
  $(document).on('click', '[data-move-to-cart]', (e) => {
    e.preventDefault();

    const productId = e.target.getAttribute('data-product-id');
    const variantId = e.target.getAttribute('data-variant-id');
    const du = e.target.getAttribute('data-url');
    e.target.innerHTML = 'Adding to Bag...';

    window._swat.replayAddToCart({ empi: productId, du, }, variantId, () => {
        // e.target.innerHTML = 'Moved to bag';
        console.log('Successfully moved product to bag.');

        // Remove from list
        $(e.target).closest('[data-cart-wishlist-item]').find('[data-remove-wishlist-item]').trigger('click');
        // window.location.reload();

        e.target.innerHTML = window.theme.strings.addedToCart;

        // The app automatically refreshed the page, cannot open the slide out cart
        // window.setTimeout(() => {
        //   openSliderCart();
        // }, 1000);
      }, (event) => {
        // console.log(event);
        e.target.innerHTML = window.theme.strings.unavailable;
      },
    );
  });
};
